import { RadioGroupItem } from "@/components/ui/radio-group";
import { View, Card, CardContent, Image } from "@/components/ui";
import { Divider } from "@/components/shared/divider";
import { cn } from "@/lib/utils";
import { Typography } from "@/components/shared/typography";
import { IfElse } from "@/components/shared/if-else";
import { CaretRight } from "@/components/shared/icons";
import { useMemo } from "react";

export const ServiceRadioCard = ({
  value,
  title,
  subTitle,
  thirdTitle,
  description,
  imgUrl,
  active,
  onSelect,
  isModal,
  alignment = "start",
}: {
  active: boolean;
  imgUrl: string;
  value: string;
  title: string;
  subTitle?: string;
  thirdTitle?: string;
  description?: string;
  onSelect(): void;
  isModal?: boolean;
  alignment?: "start" | "center";
}) => {
  const subTitleRender = useMemo(() => {
    if (subTitle?.includes("$")) {
      const subTitleArr = subTitle.split(" ");
      return (
        <View className="flex flex-row items-center gap-1">
          {subTitleArr.map((title: string) => {
            if (title.includes("$"))
              return (
                <Typography
                  key={`subtitle-${title}`}
                  variant="label-sm"
                  color="info"
                >
                  {title}
                </Typography>
              );
            return (
              <Typography
                as="span"
                key={`subtitle-${title}`}
                variant="caption-md"
              >
                {title}
              </Typography>
            );
          })}
        </View>
      );
    }
    return <Typography variant="caption-md">{subTitle}</Typography>;
  }, [subTitle]);

  const alignmentStyle = useMemo(() => {
    if (alignment === "center") {
      return "items-center";
    }

    return "items-start";
  }, [alignment]);

  return (
    <Card
      className={cn({
        "border-primary-border bg-primary-surface": active,
        "hover:border-primary-border hover:bg-primary-surface": !isModal,
      })}
      onClick={onSelect}
    >
      <CardContent
        className={cn({
          "divide-primary-border": active,
          "hover:divide-primary-border": !isModal,
        })}
      >
        <View className={cn("flex flex-row gap-4", alignmentStyle)}>
          <View className="h-16 overflow-hidden rounded-lg">
            <Image width={95} src={imgUrl} className="h-full rounded-md" />
          </View>
          <View className="flex flex-1 flex-col gap-0.5">
            <Typography variant="body-md">{title}</Typography>
            <Typography variant="caption-md" color="foreground-intermediate">
              {subTitleRender}
            </Typography>
            {thirdTitle && (
              <Typography variant="caption-md" color="foreground-intermediate">
                {thirdTitle}
              </Typography>
            )}
          </View>
          <IfElse if={!isModal} else={<CaretRight />}>
            <RadioGroupItem value={value} checkCircle />
          </IfElse>
        </View>
        <IfElse if={!!description}>
          <Divider dashed className="my-2" />
          <Typography variant="caption-md" color="foreground-intermediate">
            {description}
          </Typography>
        </IfElse>
      </CardContent>
    </Card>
  );
};
